import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MaintenanceBanner = _resolveComponent("MaintenanceBanner")!
  const _component_ForgotPassword = _resolveComponent("ForgotPassword")!
  const _component_ValidationCode = _resolveComponent("ValidationCode")!
  const _component_login_view = _resolveComponent("login-view")!
  const _component_super_admin = _resolveComponent("super-admin")!
  const _component_home_view = _resolveComponent("home-view")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (_ctx.isAuth)
        ? (_openBlock(), _createBlock(_component_MaintenanceBanner, { key: 0 }))
        : _createCommentVNode("", true),
      (!_ctx.isAuth && _ctx.isForgot)
        ? (_openBlock(), _createBlock(_component_ForgotPassword, { key: 1 }))
        : _createCommentVNode("", true),
      (!_ctx.isAuth && _ctx.isValidation)
        ? (_openBlock(), _createBlock(_component_ValidationCode, { key: 2 }))
        : _createCommentVNode("", true),
      (!_ctx.isAuth && !_ctx.isForgot && !_ctx.isValidation)
        ? (_openBlock(), _createBlock(_component_login_view, { key: 3 }))
        : (_ctx.isAuth && _ctx.isSuperAdminChoice)
          ? (_openBlock(), _createBlock(_component_super_admin, { key: 4 }))
          : (_ctx.isAuth)
            ? (_openBlock(), _createBlock(_component_home_view, { key: 5 }))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}